module.exports = __webpack_public_path__ + "img/dinkenclave-4.443a3bce.jpeg";